<template>
  <div class="product-gallery  ">
    <!-- Imagen Principal -->
    
    <div class="carousel-wrapper">
      <div class="image-container  "  :class="blogData.img < 1 ? 'bg-icon-primary' : ''">
        <div v-if="{ active: showHeart }" class="heart-animation" :class="{ active: showHeart }">
          <i class="fa-solid fa-heart"></i>
        </div>
        <div v-if="blogData.img < 1" class="no-image  "  >
            <div class="circle bg-icon-primary big" >
              <i class="fa-solid fa-image primary"></i>
            </div>
          </div>
          
        <img
        v-on:dblclick="toggleFavorito"
          v-if="blogData.img != null && blogData.img !=''"
          :src="blogData.img"
          :alt="blogData.tittle || 'Imagen principal del blog'"
          loading="eager"
          fetchpriority="high"
          class="main-image   px-xl-0 px-2 "
        />
        
        <img
        v-else
        style="opacity: 0%;"
          src="https://salonlfc.com/wp-content/uploads/2018/01/image-not-found-scaled.png"
          :alt="'Imagen del producto ' + (activeSlide + 1)"
          class="main-image px-xl-0 px-2 "
        />
      </div>
    </div>
    <!-- <div class="action-buttons">
    
      <button @click="toggleFavorito" class="icon-button">
        <i :class="['fa-heart', Favorito ? 'fa-solid  ' : 'fa-regular']"></i>
         
      </button>
    </div> -->
    
    <!-- Navegación de Miniaturas -->    
  </div>
</template>

<script>
export default {
  props:[
    "blogData"
  ],
  data() {
    return {
      activeSlide: 0,
      Favorito: false,
      showHeart: false,

      // productImages: [
      // { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/4.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/3.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/5.jpg" },
      //   { url: "https://sheltos-vue.vercel.app/image/property/6.jpg" },
      // ],
    };
  },
  methods: {
    toggleFavorito() {
      this.Favorito = !this.Favorito;
      this.triggerHeartAnimation();
    },
    triggerHeartAnimation() {
      this.showHeart = true;
      setTimeout(() => {
        this.showHeart = false;
      }, 1000); // Duración de la animación
    },
     
  },
};
</script>

<style scoped>
.heart-animation {
  z-index: 9999;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 5rem;
  color: var(--primary);
  /* color: rgb(255, 255, 255); */
  opacity: 0;
  animation: none;
}


.heart-animation.active {
  animation: heart-pop 1s ease-out forwards;
}

@keyframes heart-pop {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.7);
    opacity: 1;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

.icon-button {
  background: var(--white);
  color: var(--black);
  border: none;
  padding: 3px;
  border-radius: var(--radius);
  width: 2.2rem;
  height: 2.2rem;
  font-size: 18px;
  cursor: pointer;
  outline: none;
}
.action-buttons {
  position: absolute;
  bottom:30px;
  right: 10px;
  /* display: flex; */
  gap: 10px;
}
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: transparent; 
}
 
/* Handle */
::-webkit-scrollbar-thumb {
  background: transparent; 
  /* border-radius: 0px; */
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: transparent; 
}
.product-gallery {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-wrapper {
  width: 100%;
  /* max-width: 100%; */
  margin-bottom: 15px;
}

.image-container {
  position: relative;

  display: flex;
  justify-content: center;
  align-items: center;
  height: 70vh;
}

.main-image {
  position: relative;

  width: 100vw;
  max-width: 800px;
  /* min-height: 800px; */
  max-height: 100%;
  border-radius: 8px;
}

.thumbnails-wrapper {
  display: flex;
  /* width: 100vh !important; */
  align-items: center;
}

.thumbnails {
  width: 100vw !important;
  display: flex;
  overflow-x: auto;
  gap: 10px;
  padding: 10px;
  scroll-behavior: smooth;
}

.thumbnail {
  width: 8rem;
  /* width: 100vh !important; */
  height: 6rem;
  object-fit: cover;
  border: 2px solid transparent;
  cursor: pointer;
  transition: border-color 0.2s;
  /* border-radius: 4px; */
}

.thumbnail.active {
  /* border-color: #007bff; */
}

.thumbnail:hover {
  /* border-color: #0056b3; */
}

.nav-button {
  margin-top: -1rem;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  padding-left: 1rem !important;
  padding-right: 1rem !important;
  border-radius: 100px !important;
  transition: color 0.2s;
}
 @media (max-width: 576px) {
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30vh;
  }
} 
 @media (max-width: 720px) {
  .main-image {
height: 20vh;
  width: 100vw;
  /* max-width: 100%; */
  height: 100%;
  /* border-radius: 8px; */
}
  .image-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 20vh !important;
  }
} 

 
</style>
